<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>资源导出</span>
          </div>

          <el-form ref="form" :inline="true" label-width="100px" :model="searchData">
            <el-form-item label="导出资源所属">
              <el-select
                v-model="searchData.sourceType"
                placeholder="请选择">
                <el-option :key="1" label="原始分配" :value="1"/>
                <el-option :key="2" label="当前状态" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="用户编码">
              <el-input
                v-model="searchData.crmIds"
                class="jm-input-common"/>
            </el-form-item>
            <el-form-item label="客户分级">
              <jm-dict-select
                clearable
                type="dataset"
                v-model="searchData.customer_classify"
                dict-type="student"
                name="customLvType"
              />
            </el-form-item>
            <el-form-item label="客户评级">
              <jm-dict-select
                class="jm-input220"
                clearable
                type="dataset"
                name="studentLevel"
                dict-type="student"
                v-model="searchData.student_level"/>
            </el-form-item>
            <el-form-item label="部门">
              <el-select
                v-model="searchData.department"
                placeholder="-- 请选择 --">
                <el-option
                  :key="0"
                  label="-- 请选择 --"
                  :value="''"
                />
                <el-option
                  v-for="v in departments"
                  :key="v.id"
                  :label="v.department"
                  :value="v.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="入学时间">
              <el-date-picker
                :editable="false"
                v-model="searchData.custom_year"
                @change="() => { return this.searchData.custom_month = ''; }"
                type="year"
                placeholder="请选择"
                class="jm-input-common2"
                format="yyyy"
                value-format="yyyy"/>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                :editable="false"
                v-model="searchData.custom_month"
                :disabled="!searchData.custom_year"
                type="month"
                placeholder="请选择"
                class="jm-input-common2"
                popper-class="process-list-popper"
                format="MM"
                value-format="MM"/>
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="searchData['custom_plan_time']">以后</el-checkbox>
            </el-form-item>
            <el-form-item label="创建日期">
              <el-date-picker
                :editable="false"
                v-model="searchData.creationDate"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"/>
            </el-form-item>
            <el-form-item label="签约日期">
              <el-date-picker
                :editable="false"
                v-model="searchData.signingdate"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"/>
            </el-form-item>
            <el-form-item label="最后回访日期">
              <el-date-picker
                :editable="false"
                v-model="searchData.lastvisittime2"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"/>
            </el-form-item>
            <el-form-item label="渠道">
              <jm-channel v-model="searchData.channels" :is-all="true" clearable filterable />
            </el-form-item>
            <div class="jm-primary">
              <el-button
                class="jm-input-common2"
                type="success"
                :loading="exporting"
                @click="sendForm">导出资源</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/index.css';
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { jmChannel, jmDictSelect } from '@/components/tool';

export default {
  data() {
    return {
      searchData: {
        creationDate: [],
        signingdate: [],
        sourceType: 1,
        customer_classify: '',
        student_level: '请选择',
        department: null,
        channels: {}
      },
      exporting: false,
      departments: [],
    };
  },
  components: {
    jmToolbar,
    jmTableList,
    jmChannel,
    jmDictSelect
  },
  mounted () {
    this.$http._get({
      url: '/index/system/departments'
    }).then(({ data }) => {
      const { departments } = data;
      this.departments = departments;
    });
  },
  methods: {
    // 表单提交
    sendForm() {
      this.exporting = true;
      this.$http._post({
        url: '/index/system/resourcesExport',
        data: this.searchData,
      }).then(({ data }) => {
        let downloadName = '';
        if (this.searchData.sourceType === 1) {
          downloadName = '资源记录-原始分配.xlsx';
        } else {
          downloadName = '资源记录-当前状态.xlsx';
        }
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: downloadName
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    },
    fromChangeHandler (value, level) {
      level = Number(level);
      let swap = level;
      while (++swap <= 5) {
        this[`from${swap}`] = [];
        delete this.searchData[`from${swap}`];
      }
      if (level < 5) {
        this.$http._get({
          url: `/index/system/getFromByLevel?parent_level=${value}`
        }).then(({ data }) => {
          this[`from${level + 1}`] = data;
        });
      }
    }
  },
};
</script>
